import { defineStore } from 'pinia'
import { inject, ref } from 'vue'

const useSignupRewardStore = defineStore('signup-reward', () => {
  const api = inject('api')
  if (!api) throw new Error('Signup reward store: api provider is required')

  // 0 表示当前没有注册奖励（后台关了或还没取到），界面就不承诺送积分
  const points = ref(0)
  let loadTask = null

  function load() {
    if (loadTask !== null) return loadTask
    loadTask = api.commerce.signupReward()
      .then(offer => {
        points.value = offer.points
      })
      .catch(error => {
        // 取不到就只是不展示送积分的文案，注册入口照常可用
        console.warn('[visual-game] signup reward unavailable', error)
      })
    return loadTask
  }

  return { points, load }
})

/**
 * 注册奖励积分数：顶栏注册按钮和登录弹窗共用同一份，一次页面加载只问一次服务端。
 * 在组件 setup 里调用。
 */
export function useSignupReward() {
  const store = useSignupRewardStore()
  store.load()
  return store
}
